module.exports = __webpack_public_path__ + "img/logo.89740bc7.png";